import useLocationQuery from './useQuery';
import { DEFAULT_LIMIT } from '../components/Services/constants';
import { useEffect, useState } from 'react';

export const useTablePagination = () => {
  const { changeLocationQuery, query } = useLocationQuery();

  const handlePageChange = (_: React.ChangeEvent<HTMLDivElement>, page: number) => {
    changeLocationQuery({
      ...query,
      page
    });
  };

  const handleRowsPerPageChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { value: rowsPerPage } = e.target;

    changeLocationQuery({
      ...query,
      limit: rowsPerPage
    });
  };

  return {
    page: +query.page || 0,
    rowsPerPage: +query.limit || DEFAULT_LIMIT,
    handlePageChange,
    handleRowsPerPageChange
  };
};

export const usePersistedTotal = (dynamicTotal?: number) => {
  const [total, setTotal] = useState(0);

  useEffect(() => {
    if (typeof dynamicTotal === 'number' && dynamicTotal !== total) {
      setTotal(dynamicTotal);
    }
  }, [dynamicTotal, total])

  return total;
};
